import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
    {
        name: 'form-preview',
        props: true,
        path: '/form-preview/:id',
        component: () => LazyLoadView(import(/* webpackChunkName: "form-preview" */ '@/views/Form/Preview.vue')),
        meta: {
            skipAuth: true,
            navigation: false,
            footer: false,
        },
    },
    {
        name: 'form-submits',
        path: '/form/:id/submits',
        props: true,
        component: () => LazyLoadView(import(/* webpackChunkName: "form-submits" */ '@/views/Form/Submits.vue')),
        beforeEnter: isAuthenticated,
    },
]
